export default __webpack_public_path__ + "static/media/stem.cbfd1d4b.png";